import React, { useState, useEffect, useRef } from "react";

const Header = ({ toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false); // User profile dropdown state
  const dropdownRef = useRef(null);
  const userDropdownRef = useRef(null);
  const [counts] = useState({
    alert: 3,
    message: 2,
    order: 5,
    system: 1,
  });

  // Toggle main notification dropdown
  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Toggle user profile dropdown
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current && !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (
        userDropdownRef.current && !userDropdownRef.current.contains(event.target)
      ) {
        setUserDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          {/* Logo Section */}
          <div className="navbar-brand-box">
            <a href="#/" className="logo logo-dark">
              <span className="logo-sm">
                <img src="assets/images/logo.png" alt="logo" height={40} />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo.png" alt="logo" height={44} />{" "}
                <span className="logo-txt">Olectra</span>
              </span>
            </a>
          </div>

          {/* Sidebar Toggle Button */}
          <button
            type="button"
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
            onClick={toggleSidebar}
          >
            <i className="fa fa-fw fa-bars text-white" />
          </button>
        </div>

        {/* Right Section */}
        <div className="d-flex">
          {/* Individual Notification Icons */}
          <div className="d-inline-block">
            <button className="btn header-item noti-icon position-relative" title="Offline Vehicles">
              <i className="bx bx-bus icon-lg text-white" />
              <span className="badge bg-warning rounded-pill">{counts.alert}</span>
            </button>
          </div>

          <div className="d-inline-block">
            <button className="btn header-item noti-icon position-relative" title="Vehicles Online, Stationary & ignition off">
              <i className="bx bx-bus icon-lg text-white" />
              <span className="badge bg-warning rounded-pill">{counts.message}</span>
            </button>
          </div>

          <div className="d-inline-block">
            <button className="btn header-item noti-icon position-relative" title="Vehicles Online, Stationary & ignition On">
              <i className="bx bx-bus icon-lg text-white" />
              <span className="badge bg-warning rounded-pill">{counts.order}</span>
            </button>
          </div>

          <div className="d-inline-block">
            <button className="btn header-item noti-icon position-relative" title="Moving Vehicles with Ignition Off">
              <i className="bx bx-bus icon-lg text-white" />
              <span className="badge bg-warning rounded-pill">{counts.system}</span>
            </button>
          </div>

          {/* Main Notification Dropdown */}
          <div className="dropdown d-inline-block" ref={dropdownRef}>
            <button
              className="btn header-item noti-icon position-relative"
              onClick={handleDropdownToggle}
            >
              <i className="bx bx-bell icon-lg text-white" />
              <span className="badge bg-warning rounded-pill">
                {Object.values(counts).reduce((a, b) => a + b, 0)}
              </span>
            </button>

            {dropdownOpen && (
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                style={{ right: 0, left: "auto", position: "absolute", maxWidth: "350px" }}
              >
                <div className="p-3">
                  <h6 className="m-0">All Notifications</h6>
                </div>
                <div data-simplebar style={{ maxHeight: 230 }}>
                  <a href="#!" className="text-reset notification-item">
                    <div className="d-flex">
                      <div className="flex-shrink-0 avatar-sm me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-bus" />
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">MH12AB1234</h6>
                        <p className="mb-1">Vehicle is Online.</p>
                        <p className="mb-0"><i className="mdi mdi-clock-outline" /> 1 hour ago</p>
                      </div>
                    </div>
                  </a>

                  <a href="#!" className="text-reset notification-item">
                    <div className="d-flex">
                      <div className="flex-shrink-0 avatar-sm me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-bus" />
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">KA05CD5678</h6>
                        <p className="mb-1">Vehicle is Offline</p>
                        <p className="mb-0"><i className="mdi mdi-clock-outline" /> 5 mins ago</p>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="p-2 border-top d-grid">
                  <a className="btn btn-sm btn-link font-size-14 text-center" href="#/">
                    <i className="mdi mdi-arrow-right-circle me-1" /> <span>View More</span>
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* User Profile Dropdown */}
          <div className="dropdown d-inline-block" ref={userDropdownRef}>
            <button className="btn header-item" onClick={toggleUserDropdown}>
              <img className="rounded-circle header-profile-user" src="assets/images/users/user.jpg" alt="Header Avatar" />
              <span className="d-none d-xl-inline-block ms-1 text-white fw-medium">admin</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block text-white" />
            </button>
            {userDropdownOpen && (
              <div className="dropdown-menu dropdown-menu-end show">
                <a className="dropdown-item" href="#/">
                  <i className="mdi mdi-logout font-size-16 align-middle me-1" /> Logout
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
